import { render } from "./HealthAlertDetailDrawer.vue?vue&type=template&id=f63eb41c&scoped=true"
import script from "./HealthAlertDetailDrawer.vue?vue&type=script&lang=js"
export * from "./HealthAlertDetailDrawer.vue?vue&type=script&lang=js"

import "./HealthAlertDetailDrawer.vue?vue&type=style&index=0&id=f63eb41c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63eb41c"]])

export default __exports__